import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class BackgroundLayers extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.curSpeed = 0;
    this.destSpeed = 0;
    this.moveSpeed = 0;

    this.mainbg1 = ABCyaPhaser.Images.addImage(0, 0, 'BG1', this).setOrigin(0, 0);
    this.mainbg2 = ABCyaPhaser.Images.addImage(0, 0, 'BG2', this).setOrigin(0, 0);
    this.mainbg2.y = -768;
  }

  updateSpeed(value) {
    this.destSpeed = value;
  };

  update(e) {
    const dtime = e / 1000;

    if (this.mainbg1.y > this.scene.mid.y * 2) {
      const tmp = this.mainbg1;
      tmp.y = this.mainbg2.y - 768;
      this.mainbg1 = this.mainbg2;
      this.mainbg2 = tmp;
    }
    this.mainbg1.y += this.curSpeed * dtime;
    this.mainbg2.y += this.curSpeed * dtime;
    if (this.curSpeed < this.destSpeed) {
      this.curSpeed += 5;
      if (this.curSpeed > this.destSpeed) this.curSpeed = this.destSpeed;
    }
    else if (this.curSpeed > this.destSpeed) {
      this.curSpeed -= 5;
      if (this.curSpeed < this.destSpeed) this.curSpeed = this.destSpeed;
    }
  };
}